<template>
  <div :class="`pie-chart width-${size} height-${size} ${wrapperClass}`">
    <vue-easy-pie-chart
      class="chart"
      :percent="percent"
      :size="size"
      :line-width="lineWidth"
      :scale-length="scaleLength"
      :bar-color="barColor"
      :track-color="trackColor"
      :font-size="fontSize"
    >
      <span>{{ percent }}%</span>
    </vue-easy-pie-chart>
  </div>
</template>

<script>
import VueEasyPieChart from "vue-easy-pie-chart";
import "vue-easy-pie-chart/dist/vue-easy-pie-chart.css";

export default {
  components: { VueEasyPieChart },
  props: {
    percent: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 48,
    },
    lineWidth: {
      type: Number,
      default: 5,
    },
    scaleLength: {
      type: Number,
      default: 0,
    },
    barColor: {
      type: String,
      default: "",
    },
    trackColor: {
      type: String,
      default: "",
    },
    fontSize: {
      type: String,
      default: "12px",
    },
    wrapperClass: {
      type: String,
      default: "",
    },
  },
};
</script>

